import { PHONE_NUMBER_PATTERN } from "@eave/shared/utils/regex-patterns";
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  underwriter_phone: Yup.string()
    .matches(PHONE_NUMBER_PATTERN, "Please enter a valid phone number.")
    .nullable(),
});
